import { connect } from 'react-redux';
import { setSelectedPharmacy } from '../../../actions/user';
import Pharmacies from './';

const mapDispatchToProps = (dispatch: any) => ({
  setSelectedPharmacy: (id: string) => dispatch(setSelectedPharmacy(id))
});

export default connect(() => ({}), mapDispatchToProps)(Pharmacies);
